// src/hooks/useRetour.ts — SCE Issues
// Le bouton « retour » des pages pleines (fiche problème, déclaration).
//
// `navigate(-1)` ne suffit pas (retour du 25/09) : une fiche ouverte depuis un
// mail ou une carte Teams est la PREMIÈRE page de l'onglet. Derrière, il n'y a
// rien — ou la page de connexion Microsoft, après une redirection — et le
// bouton ne faisait rien. React Router donne la clé `default` à cette première
// entrée : dans ce cas, on va vers une page de repli, en REMPLAÇANT l'entrée
// (le retour du navigateur ne ramène pas sur la fiche).
//
// Au bureau, la fiche en surimpression a sa propre règle (ModaleRoute).

import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function useRetour(repli: string): () => void {
  const navigate = useNavigate()
  const location = useLocation()
  const premierePage = location.key === 'default'
  return useCallback(() => {
    if (premierePage) navigate(repli, { replace: true })
    else navigate(-1)
  }, [navigate, premierePage, repli])
}
